import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'image-show',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-show.html',
  styleUrl: './image-show.css',
})
export class ImageShow implements OnInit {
  @Input() data: any;
  imageSrc = '';




  get titleText(): string {
    return String(this.data?.title ?? this.data?.text ?? '').trim();
  }

  get bodyText(): string {
    return String(this.data?.description ?? this.data?.subText ?? this.data?.caption ?? '').trim();
  }

  ngOnInit(): void {
    this.imageSrc = this.resolveImagePath();

    console.log("data in image json", this.data);
  }

  private resolveImagePath(): string {
    const rawPath = String(
      this.data?.imagePath ??
      this.data?.src ??
      this.data?.imageUrl ??
      this.data?.path ??
      '',
    ).trim();

    if (!rawPath) return '';

    // Keep absolute/protocol/data URLs unchanged.
    if (
      rawPath.startsWith('/') ||
      /^https?:\/\//i.test(rawPath) ||
      rawPath.startsWith('data:')
    ) {
      return rawPath;
    }

    // Normalize app asset paths so they work on nested routes.
    if (rawPath.startsWith('./assets/')) {
      return `/${rawPath.substring(2)}`;
    }
    if (rawPath.startsWith('assets/')) {
      return `/${rawPath}`;
    }

    return rawPath;
  }

  get altText(): string {
    return String(this.data?.alt ?? this.data?.title ?? 'image').trim();
  }

  /**
   * Determine whether the image should be shown.  callers can set
   * `showImage: false` to suppress it even if an imagePath exists.
   */
  get showImage(): boolean {
    if (!this.imageSrc) {
      return false;
    }
    if (this.data?.showImage === false) {
      return false;
    }
    return true;
  }

  /**
   * HTML string provided by the config.  if present we render it directly
   * with innerHTML and skip the JSON renderer.
   */
  get htmlContent(): string {
    return String(this.data?.html ?? '').trim();
  }

  /**
   * custom text/HTML that should occupy the 'image' region when no image is
   * shown. useful for placing a title or formatted description in place of the
   * picture.
   */
  get imageText(): string {
    return String(this.data?.imageText ?? '').trim();
  }

  /**
   * text or JSON provided by the dashboard config.  objects are formatted
   * for readability.  only used when htmlContent is empty.
   */
  get jsonText(): string {
    const val = this.data?.text;
    if (val == null) {
      return '';
    }
    if (typeof val === 'string') {
      return val.trim();
    }
    try {
      return JSON.stringify(val, null, 2);
    } catch {
      return String(val);
    }
  }

  get content(): any {
    return this.data?.content;
  }

  isComplexItem(item: any): boolean {
    return item && typeof item === 'object' && item.bold != null;
  }
}
